export default function convertUserTeamSalesToCbb(
  user: any,
  onlyLabel?: boolean,
) {
  return (
    (user?.teamSales ?? []).map((item: any) => ({
      label: onlyLabel ? item.subId : item.subId + ' - ' + item.name,
      value: item.id,
      id: item.id,
    })) ?? []
  );
}
